export default __webpack_public_path__ + "static/media/slide-2.ad9c1c0d.webp";